import { ArrowUpRight } from "lucide-react";
import { Reveal, ChapterLabel } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { IMAGES } from "@/content/images";
import { PRIVATE_EXPERIENCES_EMAIL } from "@/lib/site";

const Experiences = () => {
  const { t } = useLang();
  const d = t.experiences;

  return (
    <section id="private-experiences" data-testid="private-experiences-section"
      className="bg-espresso text-ivory px-6 md:px-12 py-28 md:py-44">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 md:grid-cols-12 md:gap-12">
        <div className="md:col-span-6">
          <Reveal y={40}>
            <div className="img-frame aspect-[4/5] md:aspect-auto md:h-[115%] overflow-hidden">
              <div className="h-full w-full origin-bottom scale-[1.34]">
                <img src={IMAGES.privateExperiences} alt="Private yoga session at Cabo Yoga & Fitness studio"
                  data-testid="private-experiences-image" loading="lazy"
                  className="h-full w-full object-cover object-bottom" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-5 md:col-start-8 flex flex-col justify-center">
          <ChapterLabel index={d.chapter} title={d.label} light />
          <Reveal delay={0.1}>
            <h2 data-testid="private-experiences-headline"
              className="mt-10 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {d.headingA} <span className="italic font-light text-sand">{d.headingB}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 max-w-md text-base md:text-lg leading-relaxed text-ivory/70">{d.copy}</p>
          </Reveal>
          <Reveal delay={0.22} className="mt-10">
            <p className="label-caps text-ivory/40">{d.offeringsLabel}</p>
            <div data-testid="private-experiences-offerings" className="mt-5 flex flex-wrap gap-2.5">
              {d.offerings.map((o) => (
                <span key={o} className="rounded-full border border-ivory/25 px-4 py-1.5 text-xs tracking-[0.08em] text-ivory/80">
                  {o}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.26} className="mt-10">
            <ul data-testid="private-experiences-categories" className="divide-y divide-ivory/15 border-y border-ivory/15">
              {d.categories.map((c) => (
                <li key={c} className="group flex items-center justify-between py-4 md:py-5">
                  <span className="font-display text-xl md:text-2xl text-ivory/90 transition-colors duration-500 group-hover:text-ivory">{c}</span>
                  <ArrowUpRight size={18} strokeWidth={1.25}
                    className="text-ivory/40 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-gold" />
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.3} className="mt-10">
            <a href={`mailto:${PRIVATE_EXPERIENCES_EMAIL}?subject=Private%20Experience%20Enquiry`}
              data-testid="explore-private-experiences-button" className="btn-pill btn-outline-light">
              {d.cta}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Experiences;
